// extracted by css-extract-rspack-plugin
export default {"searchMatchText":"SearchMatchText-module__searchMatchText__aiO59","g-emoji":"SearchMatchText-module__g-emoji__akqAB","truncatedName":"SearchMatchText-module__truncatedName__uJrw4"};